import { request } from '../request'

//分页查询答卷数据
export function getAnswerSheetList(data) {
  return request({
    url: '/award/answerSettle/page',
    method: 'get',
    params: data
  })
}

//分页查询调查员任务数据
export function getVisitorSheetList(data) {
  return request({
    url: '/award/answerSettle/jobExecution/page',
    method: 'get',
    params: data
  })
}

//获取结算详情
export function getSettlementDetail(id) {
  return request({
    url: '/award/statement/detail/' + id,
    method: 'get'
  })
}

//代理确认结算单
export function settlementConfirm(data) {
  return request({
    url: '/award/statement/confirm',
    method: 'post',
    data
  })
}

//结算单调价
export function settlementAdjust(data) {
  return request({
    url: '/award/statement/adjust',
    method: 'post',
    data
  })
}

//发起结算单确认
export function initiateConfirmSettlement(data) {
  return request({
    url: '/award/statement/initiateConfirm',
    method: 'post',
    data
  })
}

//撤销结算单
export function revokeSettlement(data) {
  return request({
    url: '/award/statement/revoke',
    method: 'post',
    data
  })
}

//获取头部数据
export function answerSettleHeadInfo(data) {
  return request({
    url: '/award/answerSettle/headInfo',
    method: 'get',
    params: data
  })
}

//答卷调价
export function answerSettleAdjust(data) {
  return request({
    url: '/award/answerSettle/adjust',
    method: 'post',
    data
  })
}

//生成结算单
export function settlementCreate(data) {
  return request({
    url: '/award/statement/create',
    method: 'post',
    data
  })
}

//分页查询结算单数据
export function getSettlementList(data) {
  return request({
    url: '/award/statement/page',
    method: 'get',
    params: data
  })
}

//分页查询结算单数据
export function confirmSettlePaid(id) {
  return request({
    url: '/award/statement/confirmPaid/' + id,
    method: 'get'
  })
}

//结算单PDF
export function statementExportPDF(data) {
  return request({
    url: 'award/statementExport/exportPDF',
    method: 'get',
    params: data
  })
}
//结算单Excel
export function statementExportExcel(data) {
  return request({
    url: '/award/statementExport/exportExcel',
    method: 'get',
    params: data
  })
}

//查询答卷相关的调查员信息
export function getAnswerInterviewers(data) {
  return request({
    url: '/award/answerSettle/getInterviewers',
    method: 'get',
    params: data
  })
}

//查询结算单相关的调查员信息
export function getStatementInterviewers(data) {
  return request({
    url: '/award/statement/getInterviewers',
    method: 'get',
    params: data
  })
}

//发起支付
export function initPaySettlement(data) {
  return request({
    url: '/award/statement/initPay',
    method: 'post',
    data
  })
}

//撤销支付审批
export function cancelPaySettlement(data) {
  return request({
    url: '/award/statement/cancelPay',
    method: 'get',
    params: data
  })
}

//查询结算单支付审批信息
export function getSettlementPayInfo(data) {
  return request({
    url: '/award/statement/payInfo',
    method: 'get',
    params: data
  })
}

//进行支付审批
export function auditPaySettlement(data) {
  return request({
    url: '/award/statement/auditPay',
    method: 'get',
    params: data
  })
}

//判断是否签约
export function wjSettleIsSign(data) {
  return request({
    url: '/wjsettlement/wjSettleCompanySign/judge',
    method: 'get',
    params: data
  })
}

//获取付款人接口
export function getStaffForPay(data) {
  return request({
    url: '/wjsettlement/wjSettleStaff/getStaffForPay',
    method: 'get',
    params: data
  })
}
